import { render, staticRenderFns } from "./RepresentationSelector.vue?vue&type=template&id=48d1754a&scoped=true"
import script from "./RepresentationSelector.vue?vue&type=script&lang=ts"
export * from "./RepresentationSelector.vue?vue&type=script&lang=ts"
import style0 from "./RepresentationSelector.vue?vue&type=style&index=0&id=48d1754a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1754a",
  null
  
)

export default component.exports